import { Component, OnDestroy } from '@angular/core';
import { AlertService } from '../shared/services/alert.service';
import { Alert, AlertType } from '../_interfaces/alert';
import { filter, switchMap, tap } from 'rxjs/operators';
import { EMPTY, Observable, Subscription, timer } from 'rxjs';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css']
})
export class AlertComponent implements OnDestroy {

  constructor(private alertService: AlertService) { }

  readonly ALERT_TIMER = 5000;
  readonly ANIMATION_DELAY = 1000;
  readonly ALERT_STYLE = {
    [AlertType.Success]: 'alert-success',
    [AlertType.Error]: 'alert-danger',
    [AlertType.Info]: 'alert-info',
    [AlertType.Warning]: 'alert-warning'
  };

  alert$: Observable<Alert> = this.alertService.onAlert();

  alertTimer: Subscription = this.alertService.onAlert().pipe(
    filter((alert) => alert !== null),
    switchMap((alert: Alert) => {
      if (alert.fadeOut) {
        return timer(this.ALERT_TIMER).pipe(
          tap(() => this.removeAlert())
        );
      }

      return EMPTY;
    }
   )
  ).subscribe();

  removeAlert(): void {
    const alert = document.getElementById("alert");

    if (alert) {
      alert.classList.add('fade-out');
    }

    setTimeout(() => {
      this.alertService.clearAlert();
    }, this.ANIMATION_DELAY); 
  }

  alertClasses(alert: Alert): string {
    return this.ALERT_STYLE[alert.type];
  }

  ngOnDestroy(): void {
    if (this.alertTimer) {
      this.alertTimer.unsubscribe();
    }
  }
}

